import { EventEmitter } from 'events';
import { PopupError } from '../errors';

/**
 * @private
 */
export class Popup extends EventEmitter {
  open() {
    throw new PopupError('Unable to open a popup on this platform.');
  }

  close() {
    return this;
  }

  static isSupported() {
    return false;
  }
}



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/identity/popup.js